require('./contractAsnefError.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');
// @ commons
const WizardError = require('components/commons/wizardError/wizardError');
// @constants
const { EURO_SYMBOL } = require('constants/index');

class ContractAsnefError extends React.Component {

    render() {
        const { errorValue } = this.props;

        const value = { amount: errorValue, currency: EURO_SYMBOL }
        const valueString = getFormattedString(value)

        const title = formatText('contractsView-asnefErrorText1');
        const goBackLink = {
            label: formatText('contractEasyLoanError-goBackLinkText').toUpperCase(),
            url: 'myprofile/global'
        };

        return (
            <section className="col-xs-12 contract-asnef-error">
                <WizardError
                    errorMessage={title}
                    mainButton={goBackLink}
                >
                    <div className="contract-asnef-error__content">
                        <FormattedText
                            value="contractsView-asnefErrorText2"
                            className="contract-asnef-error__text"
                            injectedStrings={[valueString]}
                        />
                    </div>
                </WizardError>
            </section>
        );
    }
}

ContractAsnefError.propTypes = {
    errorValue: PropTypes.number.isRequired,
};

module.exports = ContractAsnefError;
